import { ISidebarMenuItem } from "@/models/sidebar-menu-item";
import { UserRoles } from "@/models/user-roles.enum";

export const sidebarMenu: ISidebarMenuItem[] = [
    {
        title: "Dashboard",
        parent: false,
        icon: "apps",
        route: { name: "dashboard" },
        userRoles: [
            UserRoles.Admin,
            UserRoles.AccountManagerAdmin,
            UserRoles.ServiceProviderAdmin,
        ],
        ifSelected: null,
    },
    {
        title: "Reports",
        parent: false,
        icon: "insert_chart",
        route: { name: "reporting" },
        userRoles: [
            UserRoles.Admin,
            UserRoles.AccountManagerAdmin,
            UserRoles.ServiceProviderAdmin,
            UserRoles.ContentProviderUser,
        ],
        ifSelected: null,
    },
    {
        title: "Providers",
        parent: true,
        icon: "assignment",
        userRoles: [
            UserRoles.Admin,
            UserRoles.AccountManagerAdmin,
            UserRoles.ServiceProviderAdmin,
        ],
        action:"expand_more",
        children: [
            {
                title: "Service Providers",
                parent: false,
                route: { name: "serviceproviders_index" },
                userRoles: [UserRoles.Admin,  UserRoles.AccountManagerAdmin ],
                ifSelected: null,
            },
            {
                title: "Content Providers",
                parent: false,
                route: { name: "contentproviders_index" },
                userRoles: [
                    UserRoles.Admin,
                    UserRoles.AccountManagerAdmin,
                    UserRoles.ServiceProviderAdmin,
                ],
                ifSelected: "sp",
            },
        ],
        ifSelected: null,
    },
    {
        title: "Users",
        parent: true,
        icon: "account_circle",
        userRoles: [
            UserRoles.Admin,
            UserRoles.AccountManagerAdmin,
            UserRoles.ServiceProviderAdmin,
        ],
        action:"expand_more",
        ifSelected: null,
        children: [
            {
                title: "Admins & Account Managers",
                parent: false,
                route: { name: "unscopedusers_index" },
                userRoles: [UserRoles.Admin],
                ifSelected: null,
            },
            {
                title: "Service Provider Users",
                parent: false,
                route: { name: "scopedusers_index" },
                userRoles: [
                    UserRoles.Admin,
                    UserRoles.AccountManagerAdmin,
                    UserRoles.ServiceProviderAdmin,
                ],
                ifSelected: "sp",
            },
            {
                title: "Content Provider Users",
                parent: false,
                route: { name: "scopedcontentproviderusers_index" },
                userRoles: [
                    UserRoles.Admin,
                    UserRoles.AccountManagerAdmin,
                    UserRoles.ServiceProviderAdmin,
                ],              
                ifSelected: "cp"
            },
        ],
        
    },
    {
        title: "Outbound Calling Numbers",
        parent: true,
        icon: "phone",
        userRoles: [
            UserRoles.Admin,
            UserRoles.AccountManagerAdmin,
            UserRoles.ServiceProviderAdmin,
            UserRoles.ContentProviderUser,
        ],
        action:"expand_more",
        ifSelected: "cp",
        children: [
            {
                title: "Manage Your Numbers",
                parent: false,
                route: { name: "anumbers_index" },
                userRoles: [
                    UserRoles.Admin,
                    UserRoles.AccountManagerAdmin,
                    UserRoles.ServiceProviderAdmin,
                    UserRoles.ContentProviderUser,
                ],
                ifSelected: "cp",
            },
            // {
            //     title: "Bulk Actions",
            //     parent: false,
            //     route: { name: "massupload_index" },
            //     userRoles: [
            //         UserRoles.Admin,
            //         UserRoles.AccountManagerAdmin,
            //         UserRoles.ServiceProviderAdmin,
            //     ],
            //     ifSelected: "cp",
            // },
            {
                title: "Grouping Numbers",
                parent: false,
                route: { name: "anumbergroups_index" },
                userRoles: [
                    UserRoles.Admin,
                    UserRoles.AccountManagerAdmin,
                    UserRoles.ServiceProviderAdmin,
                    UserRoles.ContentProviderUser,
                ],
                ifSelected: "cp",
            },
        ],
    },
    {
        title: "Assets",
        parent: false,
        icon: "star",
        userRoles: [
            UserRoles.Admin,
            UserRoles.AccountManagerAdmin,
            UserRoles.ServiceProviderAdmin,
            UserRoles.ContentProviderUser,
        ],
        route: { name: "assets_index" },
        ifSelected: "cp",
    },
    {
        title: "Programs",
        parent: false,
        icon: "forum",
        userRoles: [
            UserRoles.Admin,
            UserRoles.AccountManagerAdmin,
            UserRoles.ServiceProviderAdmin,
            UserRoles.ContentProviderUser,
        ],
        route: { name: "programcontents_index" },
        ifSelected: "cp",
    },
    // {
    //     title: "API Keys",
    //     parent: true,
    //     icon: "flag",
    //     userRoles: [
    //         UserRoles.Admin,
    //         UserRoles.AccountManagerAdmin,
    //         UserRoles.ServiceProviderAdmin,
    //     ],
    //     ifSelected: null,
    //     children: [
    //         {
    //             title: "Admin Keys",
    //             parent: false,
    //             route: { name: "unscopedserviceaccounts_index" },
    //             userRoles: [UserRoles.Admin],
    //             ifSelected: null,
    //         },
    //         {
    //             title: "Service Provider Keys",
    //             parent: false,
    //             route: { name: "scopedserviceaccounts_index" },
    //             userRoles: [
    //                 UserRoles.Admin,
    //                 UserRoles.AccountManagerAdmin,
    //                 UserRoles.ServiceProviderAdmin,
    //             ],
    //             ifSelected: "sp",
    //         },
    //     ],
    // },
];
